document.addEventListener("DOMContentLoaded", () => {
  const all_stars = document.querySelectorAll(".ruk_rating_snippet");
  // settimeout to wait for the stars to load
  setTimeout(() => {
    // remove event listeners from stars
    all_stars.forEach((star) => {
      const cloned_star = star.cloneNode(true);
      star.parentNode.replaceChild(cloned_star, star);
    });

    const product_star = document.querySelector("[scroll-to-review]");
    product_star.addEventListener("click", () => {
      // smooth scroll to reviewsio-product-reviews-widget
      let review_widget = document.querySelector(
        "reviewsio-product-reviews-widget"
      );

      const review_widget_offset = review_widget.getBoundingClientRect().top;
      // get height of sticky header
      const sticky_header = document.querySelector("store-header");
      const total_height = sticky_header.offsetHeight + 20;
      const scroll_to = review_widget_offset - total_height;

      window.scrollBy({
        top: scroll_to,
        behavior: "smooth",
      });
    });
  }, 1000);
});
